import { useMediaQuery, useWindowSize } from "@react-hookz/web";

const getBreakpoint = (breakpoint: string) => {
  if (typeof document === "undefined") return 0;
  const computedStyles = getComputedStyle(document.documentElement);
  const value = computedStyles.getPropertyValue(breakpoint);
  const pxIndex = value.indexOf("px");
  return Number.parseInt(pxIndex === -1 ? value : value.slice(0, pxIndex), 10);
};

export const breakpoints = {
  xs: getBreakpoint("--breakpoint-xs"),
  sm: getBreakpoint("--breakpoint-sm"),
  md: getBreakpoint("--breakpoint-md"),
  lg: getBreakpoint("--breakpoint-lg"),
  xl: getBreakpoint("--breakpoint-xl"),
};

type Breakpoint = keyof typeof breakpoints;

export const useBreakpoint = (breakpoint: Breakpoint) => !!useMediaQuery(`(min-width: ${breakpoints[breakpoint]}px)`);

export const useCurrentBreakpoint = (): Breakpoint => {
  const viewportWidth = useWindowSize().width;
  if (viewportWidth >= breakpoints.xl) return "xl";
  if (viewportWidth >= breakpoints.lg) return "lg";
  if (viewportWidth >= breakpoints.md) return "md";
  if (viewportWidth >= breakpoints.sm) return "sm";
  return "xs";
};
